import axios from 'axios'

import { put, call, takeLatest } from 'redux-saga/effects'

import apiConfig from '@services/apiConfig'

import {
  LIST_LOANS,
  setLoans,
  LIST_CLOSED_LOANS,
  setClosedLoans,
  REFUND_LOAN,
  setTermData,
  GET_TERM_DATA,
  setActiveTerms,
  GET_ACTIVE_TERMS
} from '../actions/loan'

import errorHandler from '../errorHandler'

const classPrefix = '/loan'

function* listLoans({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/list-loans`,
      params,
    })
    yield put(setLoans(response.data))
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

function* listClosedLoans({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/list-loans`,
      params,
    })
    yield put(setClosedLoans(response.data))
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

function* refundLoan({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'PUT',
      url: `${apiConfig.prefix + classPrefix}/refund-loan`,
      data: params,
    })
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

function* getTermData({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/get-termData`,
      params,
    })
    yield put(setTermData(response.data))
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

function* getActiveTerms({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/terms-actives`,
      params,
    })
    yield put(setActiveTerms(response.data))
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

export function* listLoansSaga() {
  yield takeLatest(LIST_LOANS, listLoans)
}

export function* listClosedLoansSaga() {
  yield takeLatest(LIST_CLOSED_LOANS, listClosedLoans)
}

export function* refundLoanSaga() {
  yield takeLatest(REFUND_LOAN, refundLoan)
}

export function* getTermDataSaga() {
  yield takeLatest(GET_TERM_DATA, getTermData)
}

export function* getActiveTermsSaga() {
  yield takeLatest(GET_ACTIVE_TERMS, getActiveTerms)
}
